import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Filtra per ruolo", -1)
const _hoisted_3 = {
  key: 0,
  class: "scrollListContainer"
}
const _hoisted_4 = { class: "scrollListItem selected d-flex justify-content-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", null, "(trova nella lista)", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "scrollListContainer",
  ref: "scrollListContainer"
}
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
    _withDirectives(_createElementVNode("select", {
      class: "form-control",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.roleFilter) = $event))
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (item) => {
        return (_openBlock(), _createElementBlock("option", { key: item }, _toDisplayString(item), 1))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.roleFilter]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      class: "form-control",
      placeholder: "Filtra per nome",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event))
    }, null, 512), [
      [_vModelText, _ctx.search]
    ]),
    (_ctx.localValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_ctx.localValue.name), 1),
            _createElementVNode("span", {
              class: "pointer fs-10",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scrollIntoView && _ctx.scrollIntoView(...args)))
            }, _hoisted_6)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredUsers, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["scrollListItem pointer", { selected: _ctx.localValue && _ctx.localValue.identifier == item.identifier }]),
          key: i,
          ref_for: true,
          ref: item.identifier,
          onClick: ($event: any) => (_ctx.emitModel(item))
        }, _toDisplayString(item.name), 11, _hoisted_8))
      }), 128))
    ], 512)
  ]))
}